import React, { useState, useEffect } from "react";
import { MDBInput } from "mdb-react-ui-kit";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import "react-responsive-pagination/themes/classic.css";
import { useHistory } from "react-router-dom";
import Select from "react-select";
// reactstrap components
import { Button, Card, CardBody, Row, Col } from "reactstrap";
import axios from "axios";
import {
  INSERT_CREDITS,
  UPDATE_CREDITS,
  FETCH_CREDITS_ID,
  ALL_CLIENT_LIST,
  CREDITS_BALANCE,
  BALANCE_CLIENT_CHNL,
  ROLE_SUPER_ADMIN_NAME,
  BALANCE_CLIENT_CHNL_RESELLER
} from "../../constants";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";

const initialState = {
  client: "",
  credits: "",
  price: "",
  pulse: "",
  channel: "",
  balance:0,
  reseller_id:0
};
let clientsList = [];
let channels = [
  {
    value: "",
    label: "Select Channel",
    isDisabled: true,
  },
  { value: "SMS", label: "SMS" },
  { value: "Whatsapp", label: "Whatsapp" },
  { value: "RCS", label: "RCS" },
  { value: "IVR", label: "IVR" },
  { value: "Email", label: "Email" },
];
let clientbalance =0;
let clientcredits =0;

const CreateCredits = (props) => {
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const notificationAlertRef = React.useRef(null);
  const [credits, setCredits] = useState(initialState);
  const [error, setError] = useState();
  const [alert, setAlert] = React.useState(null);

  let lcObj = localStorage.getItem("user");
  let lclStrge = JSON.parse(lcObj);

  useEffect(() => {
    getClients();
    props?.location?.state?.id && fetchCreditsDtls(props?.location?.state?.id);
  }, []);

  const getClients = async () => {
    setIsLoading(true);
    clientsList = [];
    await axios
      .get(`${ALL_CLIENT_LIST}?client_id=${lclStrge?.client}`)
      .then((res) => {
        res?.data?.data?.map((item) =>
        clientsList.push({ value: item.id, label: item.company_name })
      );
      })
      .catch((err) => {
        let options = {};
        options = {
          place: "tr",
          message: "Unable fetch records",
          type: "warning",
          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
      }).finally(()=>{
        setIsLoading(false);
      })
  };

  const fetchCreditsDtls = (id) => {
    axios
      .get(`${FETCH_CREDITS_ID}?id=${id}`)
      .then((res) => {
        setCredits({
          credits: res?.data?.credits,
          client: {
            value: res?.data?.client_id,
            label: res?.data?.client_name,
          },
          channel: { value: res?.data?.channel, label: res?.data?.channel },
        });
      })
      .catch((e) => {
        console.log("Exception==>", e);
      });
    //   fetchCreditBalance();
  };

  // const fetchCreditBalance = () => {
  //   let payload={
  //     client_id:18,
  //     created_dt:'2025-03-03 00:00'
  //   }
  //   axios
  //     .post(CREDITS_BALANCE,payload)
  //     .then((res) => {
  //       console.log("records-->",res);
  //     })
  //     .catch((e) => {
  //       console.log("Exception==>", e);
  //     });
  // };

  const submitpulse = async () => {
    const isvalid = validate();

    setError(isvalid);
    if (Object?.keys(isvalid)?.length === 0) {
      let payload = {
        credits: credits?.credits,
        client: credits?.client?.value,
        channel: credits?.channel?.value,
        price: credits?.price,
        pulse: credits?.pulse,
        reseller_id:credits?.reseller_id||0,
        created_by : lclStrge?.user_id,
        system_id:lclStrge?.username
      };
      if (lclStrge?.isreseller) {
        //Reseller
       payload={...payload, is_reseller:lclStrge?.isreseller,balance:Number(credits?.balance)-Number(credits?.price),balancer:(Number(credits?.price)+Number(clientbalance)||Number(credits?.price)),total_credits:(Number(clientcredits)+Number(credits?.credits)||Number(credits?.credits))} 


      }else{
        //Super admin
        payload={...payload,is_reseller:0,balance:Number(credits?.balance)+Number(credits?.price),balancer:(Number(credits?.price)+Number(clientbalance)||Number(credits?.price)),total_credits:Number(clientcredits)} 
      }
      if (props?.location?.state?.id) {
        payload = { ...payload, id: props?.location?.state?.id.toString() };
        await axios
          .post(UPDATE_CREDITS, payload)
          .then((response) => {
            let options = {};
            options = {
              place: "tr",
              message: "Updated Successfully",
              type: "success",

              autoDismiss: 2,
            };
            notificationAlertRef.current.notificationAlert(options);

            setTimeout(() => {
              navigate.push("/admin/configuration/credits");
            }, 1000);
          })
          .catch((error) => {
            console.log("catch--", error);
          });
      } else {
       
        confirmcredit(payload);
      }
    }
  };

  const confirmcredit = (payload) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => submitCredit(payload)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Add"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
        You want to Add credits ?
      </ReactBSAlert>
    );
  };

  const submitCredit = (payload) => {
    axios
      .post(INSERT_CREDITS, payload)
      .then((response) => {
        let options = {};
        options = {
          place: "tr",
          message: "Saved Successfully",
          type: "success",

          autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
        setTimeout(() => {
          navigate.push("/admin/configuration/credits");
        }, 1000);
      })
      .catch((error) => {
        console.log("catch--", error);
        let options = {};
        options = {
          place: "tr",
          message:error?.response?.data?.message,
          type: "warning",

          autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
      });
    setAlert(null);
  };

  const validate = () => {
    let errors = {};

    if (!credits?.credits) {
      errors.credits = "Credits required";
    }
    if (!credits?.client) {
      errors.client = "Client required";
    }
    if (!credits?.price) {
      errors.price = "Amount required";
    }
    if (!credits?.pulse) {
      errors.pulse = "Pulse required";
    }
    if (!credits?.channel) {
      errors.channel = "Channel required";
    }

    return errors;
  };

  const caclulateCredits = (val, name) => {
    if (name == "pulse") {
      if (Number(credits?.price ) >= Number(val)) {
        const crdts = (credits.price / val) ;
        const credit = crdts.toFixed(0);
        setCredits({ ...credits, credits: credit, pulse: val });
        setError("");
      } else {
        setCredits({ ...credits, credits: 0, pulse: val });
        setError({ pulse: "Please enter valid pulse " });
      }
    } else {
      if(val<=credits?.balance||ROLE_SUPER_ADMIN_NAME==lclStrge?.role){
        if (Number(val ) > Number(credits.pulse)) {
          const crdts = (val / credits.pulse);
          const credit = crdts.toFixed(0);
          setCredits({ ...credits, credits: credit, price: val });
          setError("");
        } else {
          setCredits({ ...credits, credits: 0, price: val });
          setError({ price: "Please enter valid price " });
        }
      }else{
        setCredits({ ...credits, credits: 0, price: val });
          setError({ price: "Please enter valid price below "+credits?.balance });
      }
     
    }
  };

  const checkBalance1=(channel)=>{
   // setCredits({ ...credits, channel: channel?.value });
   if(credits?.client?.value){
    setIsLoading(true)
    let payload={
      client : lclStrge?.role==ROLE_SUPER_ADMIN_NAME?credits?.client?.value:lclStrge?.client,
      channel : channel?.value,
      clientc:credits?.client?.value
    }
    axios
      .post(BALANCE_CLIENT_CHNL,payload)
      .then((res) => {
        const data = res?.data?.message?.reseller[0];
        clientbalance = res?.data?.message?.client[0]?.balance;
        clientcredits = res?.data?.message?.client[0]?.total_credits;
       
        setCredits({
          ...credits,balance:data?.balance||0,channel: channel,reseller_id:data?.client_id||0
        })
       
        console.log("records-->",res.data.message[0]);
      })
      .catch((e) => {
        console.log("Exception==>", e);
      })
      .finally(()=>{
        setIsLoading(false)
        setError("");
      })
   }else{
    setError({ channel: "Please Select Client " });
   }
   
  }
  const checkBalance=(channel)=>{
    if(credits?.client?.value){
      setIsLoading(true)
      let payload={
        reseller : lclStrge?.role==ROLE_SUPER_ADMIN_NAME?credits?.client?.value:lclStrge?.client,

        client:credits?.client?.value
      }
      axios
        .post(BALANCE_CLIENT_CHNL_RESELLER,payload)
        .then((res) => {
         console.log(channel);
           const data = res?.data?.message?.reseller[0];
          let pre_balance = 0;
           if(channel?.value?.toLowerCase()==="sms"){
            clientbalance = res?.data?.message?.client[0]?.smsbalance;
            pre_balance=data?.smsbalance
           }else if(channel?.value?.toLowerCase()==="ivr"){
            clientbalance = res?.data?.message?.client[0]?.ivrbalance;
            pre_balance=data?.ivrbalance
           }else if(channel?.value?.toLowerCase()==="rcs"){
            clientbalance = res?.data?.message?.client[0]?.rcsbalance;
            pre_balance=data?.rcsbalance

           }else if(channel?.value?.toLowerCase()==="email"){
            clientbalance = res?.data?.message?.client[0]?.emailbalance;
            pre_balance=data?.emailbalance

           }else if(channel?.value?.toLowerCase()==="whatsapp"){
            clientbalance = res?.data?.message?.client[0]?.whatsappbalance;
            pre_balance=data?.whatsappbalance

           }
          // clientcredits = res?.data?.message?.client[0]?.total_credits;
          // console.log("--->",clientcredits);
          setCredits({
            ...credits,balance:pre_balance||0,channel: channel,reseller_id:data?.client||0
          })
         
          console.log("records-->",res.data.message);
        })
        .catch((e) => {
          console.log("Exception==>", e);
        })
        .finally(()=>{
          setIsLoading(false)
          setError("");
        })
     }else{
      setError({ channel: "Please Select Client " });
     }
    
  }

  return (
    <>
      <LoadingScreen
        children=""
        loading={isLoading}
        bgColor="rgba(0,0,0,0.7)"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={logo}
        text="Loading..."
      ></LoadingScreen>
      {alert}
      <div className="content pd-0">
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Row>
                <Row>
                  <Col sm="10">
                    <h4
                      className="mt-4 add-content"
                      style={{ width: "200px" }}
                      onClick={() =>
                        navigate.push("/admin/configuration/credits")
                      }
                    >
                      <Button className="btn btn-icon btn-link-add btn-sm mr-2">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </Button>
                      {props?.location?.state?.id
                        ? "Update Credits"
                        : "Add Credits"}
                    </h4>
                  </Col>
                </Row>
                <Col sm="3" className="mb-4">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    placeholder="Select Client"
                    name="client"
                    value={credits?.client}
                    onChange={(value) => {
                      setCredits({ ...credits, client: value });
                    }}
                    options={clientsList}
                  />
                  <span style={{ color: "red" }}>{error?.client}</span>
                </Col>
                <Col sm="3" className="mb-4">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    placeholder="Select Channel"
                    name="channel"
                    value={credits?.channel}
                    onChange={(value) => {
                      checkBalance(value)
                      
                    }}
                    options={channels}
                  />
                  <span style={{ color: "red" }}>{error?.channel}</span>
                </Col>
                <Col sm="2" className="mb-4">
                  <MDBInput
                    label="Reseller Balance(INR)"
                    type="number"
                    name="balance"
                    readOnly={true}
                    value={credits?.balance}
                    //  onChange={e => setCredits({...credits,credits:e.target.value})}
                  />
                  <span style={{ color: "red" }}>{error?.credits}</span>
                </Col>
                <Col sm="2" className="mb-4">
                  <MDBInput
                    label="Amount(INR)"
                    type="number"
                    name="price"
                    maxLength={100}
                    value={credits?.price}
                    onChange={(e) =>
                      caclulateCredits(e?.target?.value, "amount")
                    }
                    //onChange={e => setCredits({...credits,price:e.target.value})}
                  />
                  <span style={{ color: "red" }}>{error?.price}</span>
                </Col>

                <Col sm="2" className="mb-4">
                  <MDBInput
                    label="Pulse(INR)"
                    type="number"
                    name="pulse"
                    value={credits?.pulse}
                    onChange={(e) =>
                      caclulateCredits(e?.target?.value, "pulse")
                    }
                  />
                  <span style={{ color: "red" }}>{error?.pulse}</span>
                </Col>
                
                <Col sm="2" className="mb-4">
                  <MDBInput
                    label="credits"
                    type="number"
                    name="credits"
                    readOnly={true}
                    maxLength={100}
                    value={credits?.credits}
                    //  onChange={e => setCredits({...credits,credits:e.target.value})}
                  />
                  <span style={{ color: "red" }}>{error?.credits}</span>
                </Col>
              </Row>
              <Row>
                <Col sm="12" className="">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary mt-4 pull-right"
                    onClick={() => submitpulse()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default CreateCredits;
